import React, { Component, PropTypes } from 'react';
import navDeposit from './../payment/navdeposit/index.js';
import pendingwithdrawals from './../payment/pendingwithdrawals/index.js';
import { closeStepsDepositflow, confDepositWithdraw as conf } from './../payment/common/lib/utils/router-config.js';

class DepositWithdraw extends Component {
	componentWillMount() {
		const { push } = this.props.history;
		/* close any previously opened modules */
		closeStepsDepositflow({
			bonus: true,
			pendingwithdrawals: false,
			payment: true,
			depositResult: true
		});
		navDeposit.init(conf);
		pendingwithdrawals.init({
			wrapElmSelector: '#js-deposit-pendingwithdrawals',
			textkeys: conf.textkeys.selector,
			origin: 'deposit',
			isEmptyCallback() {
				/* If no pending withdrawals exist, the step shall be skipped.
				When this is done the bonus-page is shown, and
				the backbutton must be updated  to close the flow or
				not go back to pending withdrawals, which creates a looping back button.*/
				//dispatchRoute('DEPOSIT_BONUS_NOPENDING');
				//replaceRoute('DEPOSIT_BONUS_NOPENDING');
				push('/account/deposit/bonusnp');
			}
		});
	}

	componentWillUnmount() {

	}

	render() {
		return (
			<div id="deposit-withdraw" />
		);
	}
}

DepositWithdraw.propTypes = {
	history: PropTypes.object
};

export default DepositWithdraw;



// WEBPACK FOOTER //
// ./mobile-core/src/components/deposit-withdraw.js